import dayjs from 'dayjs';

const SYSNOW: string | undefined = import.meta.env.VITE_SYSNOW
const ENVIRONMENT: string | undefined = import.meta.env.VITE_ENVIRONMENT as string

let now: dayjs.Dayjs;

if (ENVIRONMENT === "development" && SYSNOW !== undefined && SYSNOW.length > 0) {
    now = dayjs(SYSNOW)
} else {
    now = dayjs()
}

export default now
